// extracted by mini-css-extract-plugin
export default {"areasContainer":"Approach_areasContainer__-KMHg"};